import {
  Box,
  Grid,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React, { useState, useEffect } from "react";
import { FaUserEdit } from "react-icons/fa";
import { EditUserModal } from "./Modals";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  userName: {
    color: theme.palette.primary.dark,
    fontSize: 22,
    fontWeight: 500,
  },
  subHead: {
    margin: 0,
    fontSize: 18,
    fontWeight: 550,
    width: "170px",
  },
  contactBox: {
    display: "flex",
    flexWrap: "wrap",
    padding: "8px 0",
    margin: "0px",
    borderBottom: `1px solid ${theme.palette.secondary.dark}`,
  },
}));

function Profile(props) {
  const classes = useStyles();
  const [editModal, setEditModal] = useState(false);
  const { user } = props;

  const handleOpenModal = () => {
    setEditModal(true);
  };

  const handleCloseModal = () => {
    setEditModal(false);
  };

  useEffect(() => {
    console.log('User Data:', user);
  }, [user]);

  if (!user || !user.author) {
    return <Skeleton animation="wave" />;
  }

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <h2 className={classes.tabHeading}>My Profile</h2>
        <IconButton onClick={handleOpenModal}>
          <FaUserEdit />
        </IconButton>
      </Box>

      <Box>
        <p>
          Hello <span className={classes.userName}>{user.author.name}</span>,
        </p>
        <Typography variant="subtitle2" mb={5}>
          From your My Profile Dashboard you have the ability to view a
          snapshot of your recent account activity and update your account
          information.
        </Typography>

        <div style={{ marginTop: "30px" }}>
          <Grid container spacing={2}>
            {/* EMAIL */}
            <Grid item xs={12} md={3} lg={2}>
              <h3 className={classes.subHead}>Email</h3>
            </Grid>
            <Grid item xs={12} md={9} lg={10}>
              <p style={{ margin: 0 }}>{user.author.email}</p>
            </Grid>

            {/* NAME */}
            <Grid item xs={12} md={3} lg={2}>
              <h3 className={classes.subHead}>Name</h3>
            </Grid>
            <Grid item xs={12} md={9} lg={10}>
              <p style={{ margin: 0 }}>{user.author.name}</p>
            </Grid>

            {/* Phone No. */}
            <Grid item xs={12} md={3} lg={2}>
              <h3 className={classes.subHead}>Phone No.</h3>
            </Grid>
            <Grid item xs={12} md={9} lg={10}>
              <p style={{ margin: 0 }}>{user.phone_number}</p>
            </Grid>

            {/* Biography */}
            <Grid item xs={12} md={3} lg={2}>
              <h3 className={classes.subHead}>Biography</h3>
            </Grid>
            <Grid item xs={12} md={9} lg={10}>
              <p style={{ margin: 0 }}>{user.author_biography}</p>
            </Grid>

            {/* Status */}
            <Grid item xs={12} md={3} lg={2}>
              <h3 className={classes.subHead}>Status</h3>
            </Grid>
            <Grid item xs={12} md={9} lg={10}>
              <p style={{ margin: 0 }}>
                {!user.isRestricted
                  ? "Approved"
                  : !user.isBlacklisted
                  ? "Requested for Approval"
                  : "Blacklisted"}
              </p>
            </Grid>
          </Grid>
        </div>
      </Box>
      
      <EditUserModal
        visible={editModal}
        closeModal={handleCloseModal}
        userId={user._id}
        name={user.author.name}
        phone={user.phone_number}
        biography={user.author_biography}
      />
    </div>
  );
}

export default Profile;
